// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import WhoWeAreSection from '../components/WhoWeAreSection';
import CareThatMattersSection from '../components/CareThatMattersSection';
import BestCaregiversSection from '../components/BestCaregiversSection';
import CarePillarsSection from '../components/CarePillarsSection';
import SupportCtaSection from '../components/SupportCtaSection';
import PartnerInCareSection from '../components/PartnerInCareSection';
// Community/blog section hidden until real content is available.
// import CommunitySection from '../components/CommunitySection';

const HomePage = () => {
  return (
    <div className="bg-white">
      <Hero />
      <WhoWeAreSection />
      <CareThatMattersSection />
      <BestCaregiversSection />
      <CarePillarsSection />
      <SupportCtaSection />
      <PartnerInCareSection />
      {/* <CommunitySection /> hidden until real content is available */}
    </div>
  );
};

export default HomePage;
